var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7723 7.49588C23.4523 7.49588 23.1185 7.60088 22.8748 7.84088L11.991 18.5834C11.6698 18.8996 11.3473 18.8409 11.0948 18.4684L7.34977 12.9434C6.96726 12.3796 6.16726 12.2221 5.59351 12.5984C5.02101 12.9746 4.86101 13.7609 5.24351 14.3246L8.98726 19.8496C10.1148 21.5109 12.311 21.7221 13.7473 20.3096L24.6698 9.60586C25.156 9.12586 25.156 8.32088 24.6698 7.84088C24.426 7.60088 24.091 7.49588 23.7723 7.49588Z",
    fill: "#2A343D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjCheck);
export default __webpack_public_path__ + "static/media/ObjCheck.d60faa224c221c6adeb7cca4c699ad5d.svg";
export { ForwardRef as ReactComponent };